import { createUseStyles } from 'react-jss';
import vars, { base, colors, shadows, zIndex } from '../../css/vars';

export default createUseStyles({
  notifications: {
    position: 'fixed',
    bottom: base(),
    left: '50%',
    transform: 'translate3d(-50%, 0, 0)',
    zIndex: zIndex.modal,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  notification: {
    backgroundColor: colors.red,
    color: colors.white,
    padding: base(0.25),
    display: 'flex',
    alignItems: 'center',
    borderRadius: vars.borderRadius,
    boxShadow: shadows.xs,
    '&:not(:last-child)': {
      marginBottom: base(0.5),
    },
  },
});
